import { createRoot } from "solid-js";

import createUpdate from "@repo/signals/createUpdate";

export const invalidate = createRoot(() => createUpdate());

export const remount = createRoot(() => createUpdate());
